import React from "react";
import Separator from "../../common/separator/index";
import {SkillsData} from "../../data/skills";
import SkillCard from "./skill-card";
function Skills() {
  const data = SkillsData;
  return (
    <div className="flex flex-col w-full">
    <label className="text-3xl font-semibold">Skills</label>
    <Separator />
    <div>
      {data.map((item) => {
        return (
          <div className="flex justify-between mx-3 my-0">
            <label className="text-2xl font-medium">{item.type}</label>
            <div className="flex flex-wrap md:max-w-[70%] justify-end mt-5">
              {item.list.map((skill) => {
                return <SkillCard skill={skill} />;
              })}
            </div>
          </div>
        );
      })}
    </div>
  </div>
 );
}

export default Skills;